import doctorim from "./doctorim.png";
import women from "./womenIcon.png";
import loader from "./loader.gif";
import hasidaLoader from "./hasidaLoader.gif";


export const Doctorim = doctorim;
export const Women = women;
export const Loader = loader;
export const HasidaLoader = hasidaLoader;
